
import './App.css'
// import {useEffect, useState} from 'react'
import Navbar from './components/Navbar'; 
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import Home  from './components/pages/Home';
import Work from './components/pages/Work';
import Services from './components/pages/Services';
import About from './components/pages/About';
import Contact from './components/pages/Contact';
import Layout from './Layout';
import SmoothScroll from "./components/SmoothScroll";
import ThankYou from './components/pages/ThankYou';
import {PrivacyPolicy} from './components/pages/PrivacyPolicy';
import {TermsConditions} from './components/pages/TermsConditions';
import { RefundPolicy } from './components/pages/RefundPolicy';
import { NotFound } from './components/pages/NotFound';
import { LeadForm } from './components/pages/LeadForm.jsx';


import BrandBuilding from './components/pages/services/BrandBuilding';
import WebUiUxDesign from './components/pages/services/WebUiUxDesign.jsx';
import WebDevelopmentECommerce from './components/pages/services/WebDevelopmentECommerce.jsx';
import SocialMediaMarketing from './components/pages/services/SocialMediaMarketing.jsx';


// import AppDesignDev from './components/pages/services/AppDesignDev.jsx';


import { AppProvider } from "./components/AppProvider.jsx";
import $ from 'jquery';
import MarketingCollateral from './components/pages/services/MarketingCollateral.jsx';
import MotionGraphics from './components/pages/services/MotionGraphics.jsx';
const services = ['Brand Building', 'Web & UI/UX Design', 'Web Development & E-Commerce', 'Social Media & Marketing Collateral', 'Motion Graphics'];


const router = createBrowserRouter(
  [
    {"path" : "/",
      element: <><SmoothScroll /><AppProvider><Layout /></AppProvider></>,
      children: [
        {index: true, element: <Home/>},
        {path: "work", element: <Work />},
        {path: "services", element: <Services />},
        {path: "about", element: <About />},
        {path: "contact", element: <Contact services={services} />},
        {path: "thankyou", element: <ThankYou />},
        {path: "/services/brand-building", element: <BrandBuilding />},
        {path: "/services/web-ui-ux-design", element: <WebUiUxDesign />},
        {path: "/services/web-development-e-commerce", element: <WebDevelopmentECommerce />},
        {path: "/services/social-media-marketing", element: <SocialMediaMarketing />},
        {path: "/services/marketing-collateral", element: <MarketingCollateral />},
        {path: "/services/motion-graphics", element: <MotionGraphics />},
        
        {path: "/privacy-policy", element: <PrivacyPolicy />},
        {path: "/terms-conditions", element: <TermsConditions  />},
        {path: "/refund-policy", element: <RefundPolicy />},
        {path: "/not-found", element: <NotFound />},


        {path: "/__leadform", element: <LeadForm />},
        
        {path: "*", element: <Navigate to="/not-found" replace />},
        

        
        
        
      
        
      ]
    },
   
    
  ]
);
function App() {
  return (
    <>
      <RouterProvider router={router} />
    </>
  )
}

export default App
